import { cardItems } from '@/mocks/homepage';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          深度爆料
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          深度调查报道，还原网红圈内幕真相
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer hover:border-primary-300 transition-all"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="text-base font-bold text-foreground-800 font-heading mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.excerpt}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardItems.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer hover:border-primary-300 transition-all flex flex-col sm:flex-row"
            >
              <div className="sm:w-48 aspect-video sm:aspect-auto overflow-hidden bg-background-200 shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex-1 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="text-sm font-bold text-foreground-800 font-heading mb-1 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.excerpt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}